import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <div className="mt-24 pb-8 flex justify-center">
        <a href="https://terminalvalue.io/tool/concentration-of-risk" target="_blank" rel="noopener noreferrer" data-testid="terminalvalue-badge">
          <img src="https://terminalvalue.io/api/badges/concentration-of-risk.svg?style=standard" alt="Featured on TerminalValue.io" width="230" height="54" loading="lazy" />
        </a>
      </div>
      <footer className="border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col gap-4 text-sm text-neutral-500">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p>Concentration of Risk · Data sourced from SEC EDGAR · ASC 275 &amp; ASC 825 · Not financial advice</p>
            <div className="flex items-center gap-6">
              <Link to="/screener" className="hover:text-neutral-900">Screener</Link>
              <Link to="/who-buys" className="hover:text-neutral-900">Customer Map</Link>
              <a href="https://www.sec.gov/edgar" target="_blank" rel="noreferrer" className="hover:text-neutral-900">SEC EDGAR</a>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-border pt-4 text-xs text-neutral-400">
            <p>© {new Date().getFullYear()} Concentration of Risk. All rights reserved.</p>
            <div className="flex items-center gap-5">
              <Link data-testid="footer-privacy" to="/privacy" className="hover:text-neutral-900">Privacy Policy</Link>
              <Link data-testid="footer-terms" to="/terms" className="hover:text-neutral-900">Terms of Use</Link>
              <Link data-testid="footer-sitemap" to="/sitemap" className="hover:text-neutral-900">Sitemap</Link>
              <Link data-testid="footer-contact" to="/contact" className="hover:text-neutral-900">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
